import React from "react";
import { Stepper } from "@shoptet/ui";
import { useTranslation } from "react-i18next";

export enum StepsT {
  STEP_SETUP,
  STEP_SUGGESTION,
  STEP_IMAGE,
  STEP_TEXT,
  STEP_CHECK,
}

type ProgressStepperPropsT = {
  currentStep: StepsT;
};

// The Google wizard used to draw its own stepper - absolutely positioned labels over hand-placed
// connector lines, with the active label in `--app-primary` and completed ones in the muted text
// colour, which read poorly. It now renders the same design system Stepper the Meta wizard uses.
export const ProgressStepper = ({ currentStep }: ProgressStepperPropsT) => {
  const { t } = useTranslation("translation", { keyPrefix: "Components.WizardStepper" });
  const steps: [string, string, ...string[]] = [
    t("Settings"),
    t("Generate segguestion"),
    t("Banner slection"),
    t("Text selection"),
    t("Check"),
  ];

  // `StepsT` is a zero-based enum, `Stepper` counts its steps from 1.
  return <Stepper activeStep={currentStep + 1} steps={steps} />;
};
